//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import ReactGA from "react-ga";
import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import swal from "sweetalert";

//......keep this import at last......
import { useStyles } from "./Styles";

function ContactMe() {
  const classes = useStyles();
  const [mobNumError, triggerMobNumError] = React.useState(false);
  const [mobNumErrorMsg, setMobNumErrorMsg] = React.useState("");
  const [contactMeForm, setContactMeForm] = React.useState({
    Type: "Contact enquiry",
    Name: "",
    Email: "",
    contactNumber: "",
    message: "",
    latitudeOfUser: "",
    longitudeOfUser: "",
  });
  const handleBooking = () => {
    if (
      contactMeForm.Name !== "" &&
      contactMeForm.Email !== "" &&
      contactMeForm.contactNumber !== "" &&
      contactMeForm.message !== "" &&
      contactMeForm.latitudeOfUser !== "" &&
      contactMeForm.longitudeOfUser !== ""
    ) {
      sendFeedback("template_XdTVpsBi", {
        from_name: contactMeForm.Name,
        request_type: contactMeForm.Type,
        user_email: contactMeForm.Email,
        user_contactNumber: contactMeForm.contactNumber,
        user_message: contactMeForm.message,
        user_latitude: contactMeForm.latitudeOfUser,
        user_longitude: contactMeForm.longitudeOfUser,
      });
    } else {
      swal(
        "Oops!",
        "Please fill all the details and grant location access",
        "error"
      );
    }
  };

  const sendFeedback = (templateId, variables) => {
    window.emailjs
      .send("gmail", templateId, variables)
      .then((res) => {
        swal("Thank you :)", "Would love to hear from you", "success");
      })
      .catch((err) => swal("oops!", "Some technical issue occured", "error"));
  };
  const userHandleNumber = (event) => {
    event.preventDefault();

    if (event.target.value.length > 10) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Incorrect Number!");
    } else if (/^[7|8|9]{10}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Invalid number!!");
    } else if (!/^[789]{1}[0-9]{9}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg(
        "maintain the format please! (valid number start with 7,8 or 9)"
      );
    } else {
      triggerMobNumError(false);
      setMobNumErrorMsg("");
      setContactMeForm({
        ...contactMeForm,
        [event.target.name]: event.target.value,
      });
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) =>
      setContactMeForm({
        ...contactMeForm,
        longitudeOfUser: position.coords.longitude,
        latitudeOfUser: position.coords.latitude,
      })
    );
  }, []);

  return (
    <React.Fragment>
      <div
        id="otherComponents"
        className={classes.otherComponents}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <div>
          <Typography
            variant="h5"
            color="inherit"
            className=""
            style={{ fontSize: "3.4vw" }}
          >
            Drop me an e-mail <br />
            <br />
          </Typography>
        </div>
        <div
          style={{
            padding: "14px",
          }}
        >
          <FormGroup className={classes.contactForm}>
            <Grid container spacing={3}>
              {/* <label className={classes.contactMeLabels}>Name:</label> */}
              <Grid item xs={12}>
                <TextField
                  required
                  type="text"
                  id="Name"
                  name="Name"
                  label="What your mom calls you?"
                  fullWidth
                  autoComplete="name"
                  autoFocus
                  onChange={(event) => {
                    setContactMeForm({
                      ...contactMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
              {/* <label className={classes.contactMeLabels}>Email:</label> */}
              <Grid item xs={12}>
                <TextField
                  required
                  type="email"
                  id="Email"
                  name="Email"
                  label="What's your email ID?"
                  fullWidth
                  autoComplete="email"
                  onChange={(event) => {
                    setContactMeForm({
                      ...contactMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
              {/* <label className={classes.contactMeLabels}>Contact Number:</label> */}
              <Grid item xs={12}>
                <TextField
                  required
                  id="contactNumber"
                  name="contactNumber"
                  label="How may I contact you?"
                  fullWidth
                  autoComplete="contactNumber"
                  onChange={userHandleNumber}
                  error={mobNumError ? true : false}
                  helperText={mobNumErrorMsg}
                />
              </Grid>
              {/* <label className={classes.contactMeLabels}>Message:</label> */}
              <Grid item xs={12}>
                <TextField
                  required
                  multiline
                  type="input"
                  id="message"
                  name="message"
                  label="What message you want to pass?"
                  fullWidth
                  autoComplete="message"
                  onChange={(event) => {
                    setContactMeForm({
                      ...contactMeForm,
                      [event.target.name]: event.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
            <br />
            <Button variant="contained" color="primary" onClick={handleBooking}>
              Submit
            </Button>
          </FormGroup>
        </div>
      </div>
    </React.Fragment>
  );
}
export default ContactMe;

ReactGA.event({
  category: "Contact me",
  action: "Contact me clicked",
});
